import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import Colors from '../Constant/Colors';
import { Link } from 'react-router-dom';

const HomeComponent = (props) => {
  const { Children } = props;
  return (
    <>
      <div style={{ backgroundColor: '#f4ede4' }}>
        <Box display="flex" justifyContent="space-between" position={'relative'} p={2} backgroundColor={Colors.primary}>
          <Box display="flex">
            <Typography
              variant="h4"
              marginLeft="18px"
              color={'white'}
              style={{
                fontVariant: 'small-caps',
                fontWeight: '600',
                letterSpacing: 1,
                textShadow: '1px 1px 5px #370898',
              }}>
              <Link to="/" style={{ textDecoration: 'none', color: 'white' }}>
                IconicArt
              </Link>
            </Typography>
          </Box>
          <Box display="flex" gap="30px" borderRadius="25px">
            <Button
              variant="outlined"
              sx={{
                color: 'white',
                borderColor: 'white',
                width: '60%',
                borderRadius: 10,
                '&:hover': {
                  backgroundColor: '#fff',
                  color: 'black',
                },
              }}
              href="/register">
              Signup
            </Button>
            <Button
              variant="contained"
              sx={{
                width: '180px',
                backgroundColor: Colors.secondary,
                color: 'black',
                borderRadius: 10,
                '&:hover': {
                  backgroundColor: '#fff',
                  color: 'black',
                },
              }}
              href="/login">
              Login
            </Button>
          </Box>
        </Box>
      </div>
      <div>
        <Children />
      </div>
    </>
  );
};

export default HomeComponent;
